export default __webpack_public_path__ + "0b5d134.png";